import { ReactElement } from "react";
import { Box } from "@twilio-paste/core/box";
import MarkdownIt from "markdown-it";
import TurndownService from "turndown/lib/turndown.browser.umd";

import { ChatBubbleContentProps } from "@twiliointernal/e2-commons-shared-definitions";

// Render Rules
// Makes rendered links open new tab. Taken from https://github.com/markdown-it/markdown-it/blob/master/docs/architecture.md#renderer
const renderLinksWithTargetBlank = (renderer: MarkdownIt) => {
  // Need to retain default render, we're only modifying token parsing
  const defaultRender =
    renderer.renderer.rules.link_open ||
    function (tokens, idx, options, _, self) {
      return self.renderToken(tokens, idx, options);
    };

  renderer.renderer.rules.link_open = function (
    tokens,
    idx,
    options,
    env,
    self
  ) {
    // Add a new `target` attribute, or replace the value of the existing one.
    tokens[idx].attrSet("target", "_blank");

    // Pass the token to the default renderer.
    return defaultRender(tokens, idx, options, env, self);
  };
};

const MarkdownPreview = (props: ChatBubbleContentProps): ReactElement => {
  const initializeMarkdownRenderer = (): MarkdownIt =>
    new MarkdownIt({
      breaks: true,
      linkify: true,
    }).disable(["image", "heading"]);
  const turnDownService = new TurndownService();

  const { value, isHtml = false } = props;
  const markdownRenderer = initializeMarkdownRenderer();

  // setup render rules
  renderLinksWithTargetBlank(markdownRenderer);

  // Convert HTML string to markdown before rendering markdown.
  const markdownValue = isHtml ? turnDownService.turndown(value) : value;

  return (
    <Box
      dangerouslySetInnerHTML={{
        __html: markdownRenderer.render(markdownValue),
      }}
    />
  );
};

export default MarkdownPreview;
